import script from "./tabs.vue?vue&type=script&setup=true&lang=js"
export * from "./tabs.vue?vue&type=script&setup=true&lang=js"

import "./tabs.vue?vue&type=style&index=0&id=4a83b068&lang=css"

const __exports__ = script;

export default __exports__